









import Vue from 'vue';
import BaseButton from '../atoms/BaseButton.vue';
import BaseText from '../atoms/BaseText.vue';

export default Vue.extend({
  components: {
    BaseButton,
    BaseText
  }
})
